import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ReactNode } from 'react';

export interface TabItem {
  value: string;
  label: ReactNode;
  content: ReactNode;
  disabled?: boolean;
}

export function Tabs({ label, items, value, defaultValue, onValueChange }: { label: string; items: TabItem[]; value?: string; defaultValue?: string; onValueChange?: (value: string) => void }) {
  return (
    <TabsPrimitive.Root value={value} defaultValue={defaultValue ?? items[0]?.value} onValueChange={onValueChange}>
      <TabsPrimitive.List aria-label={label} className="bb-tabs__list">
        {items.map((item) => (
          <TabsPrimitive.Trigger key={item.value} value={item.value} disabled={item.disabled} className="bb-tab">
            {item.label}
          </TabsPrimitive.Trigger>
        ))}
      </TabsPrimitive.List>
      {items.map((item) => (
        <TabsPrimitive.Content key={item.value} value={item.value}>
          {item.content}
        </TabsPrimitive.Content>
      ))}
    </TabsPrimitive.Root>
  );
}
